<template>
	<div>
		<header class="page-title">
			<h2>{{ userGeneral.first_name + ' ' + userGeneral.last_name }}</h2>
			<div class="ml-auto">
				<a v-if="userRoles.includes('users.delete') && !userGeneral.authorOnArticles" href="#" @click="deleteResource(userGeneral.id,userGeneral.first_name)" class="btn btn-mb btn-danger"><i class="fas fa-trash"></i> Delete</a>
				<a href="#" class="btn btn-md btn-success" @click="saveGeneral"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="flex box">
			<div class="eight-lg">
				<div class="card">
					<header class="card-header">
						<h3 class="card-title">General Information</h3>
					</header>
					<div class="card-body">
						<div class="flex box">
							<div class="three text-center">
								<label v-if="!image" class="file-upload" for="image-avatar">
									<input id="image-avatar" type="file" ref="file" name="image-avatar" @change="handleFileUpload()">
									<span><i class="fas fa-upload"></i>&nbsp; Upload your avatar here.</span>
								</label>
								<div v-else>
									<img class="avatar" :src="image">
									<div class="text-center mt-1">
										<input id="change-image-avatar" class="hidden" type="file" ref="fileChange" name="image-avatar" @change="handleFileUpload()">
										<button class="btn btn-sm btn-primary" :disabled="inProgress" @click="$refs.fileChange.click()">Change</button>
									</div>
								</div>
							</div>
							<div class="nine">
								<div class="flex box start">
									<div class="form-group six">
										<label for="firstname">First Name</label>
										<input id="firstname" class="input-large" type="text" required v-model="userGeneral.first_name">
										<p class="input-error" v-if="errors.errors['general_first_name']">{{ errors.errors['general_first_name'] }}</p>
									</div>
									<div class="form-group six">
										<label for="lastname">Last Name</label>
										<input id="lastname" class="input-large" type="text" required v-model="userGeneral.last_name">
										<p class="input-error" v-if="errors.errors['general_last_name']">{{ errors.errors['general_last_name'] }}</p>
									</div>
								</div>
								<div class="form-group">
									<label for="email">Email Address</label>
									<input id="email" type="email" value="" required v-model="userGeneral.email">
									<p class="input-error" v-if="errors.errors['general_email']">{{ errors.errors['general_email'] }}</p>
								</div>
								<div class="flex box start" v-if="userRoles.includes('hr.create')">
									<div class="form-group four">
										<label for="birthday">Birthday</label>
										<input id="birthday" type="date" value="" required v-model="userGeneral.birthday">
										<p class="input-error" v-if="errors.errors['general_birthday']">{{ errors.errors['general_birthday'] }}</p>
									</div>
									<div class="form-group four">
										<label for="workstart">Work started</label>
										<input id="workstart" type="date" value="" required v-model="userGeneral.workstart">
										<p class="input-error" v-if="errors.errors['general_workstart']">{{ errors.errors['general_workstart'] }}</p>
									</div>
									<div class="form-group two">
										<label for="total_days_off">Total D/O</label>
										<input id="total_days_off" type="number" value="" v-model="userGeneral.total_days_off">
										<p class="input-error" v-if="errors.errors['general_total_days_off']">{{ errors.errors['general_total_days_off'] }}</p>
									</div>
									<div class="form-group two">
										<label for="remaining">Rem. D/O</label>
										<input disabled id="remaining" type="number" :value="userGeneral.remainingDayOffs">
									</div>
								</div>
								<div class="flex box start" v-if="!userRoles.includes('hr.create')">
									<div class="form-group four">
										<label for="birthday">Birthday</label>
										{{userGeneral.birthday}}
									</div>
									<div class="form-group four">
										<label for="workstart">Work started</label>
										{{userGeneral.workstart}}
									</div>
									<div class="form-group two">
										<label for="workstart">Total D/O</label>
										{{userGeneral.total_days_off}}
									</div>
									<div class="form-group two">
										<label for="remaining">Rem. D/O</label>
										{{userGeneral.remainingDayOffs}}
									</div>
								</div>
								<div class="form-group" v-if="userRoles.includes('hr.create')">
									<label for="office_country">Location</label>
									<label class="label-checkbox">
										<input id="HU" type="radio" value="hu" v-model="userGeneral.office_country" name="office_country"> Hungary
									</label>
									<label class="label-checkbox">
										<input id="UK" type="radio" value="uk" v-model="userGeneral.office_country" name="office_country"> United Kingdom
									</label>
								</div>
								<div class="form-group">
									<label for="line-manager-id">Line manager</label>
									<select id="line-manager-id" v-model="userGeneral.line_manager_id">
										<option v-for="lineManager in userGeneral.lineManagers" :value="lineManager.id">{{ lineManager.full_name }}</option>
									</select>
									<p class="input-error" v-if="errors.errors['general_line_manager_id']">{{ errors.errors['general_line_manager_id'] }}</p>
								</div>
								<hr>
								<div class="form-group">
									<label for="twitter">Twitter Profile URL</label>
									<input id="twitter" name="social[twitter]" type="url" v-model="userSocial.twitter">
									<p class="input-error" v-if="errors.errors['social_twitter']">{{ errors.errors['social_twitter'] }}</p>
								</div>
								<div class="form-group">
									<label for="linkedin">LinkedIn Profile URL</label>
									<input id="linkedin" name="social[linkedin]" type="url" v-model="userSocial.linkedin">
									<p class="input-error" v-if="errors.errors['social_linkedin']">{{ errors.errors['social_linkedin'] }}</p>
								</div>
								<div class="form-group">
									<label for="facebook">Facebook Profile URL</label>
									<input id="facebook" name="social[facebook]" type="url" v-model="userSocial.facebook">
									<p class="input-error" v-if="errors.errors['social_facebook']">{{ errors.errors['social_facebook'] }}</p>
								</div>
								<hr>
								<div class="form-group">
									<label>Personal VPN Choice</label>
									<select v-model="userVpnChoice">
										<option :value="index" v-for="(provider, index) in providers">{{ provider.name }}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<aside class="four-lg">
				<div class="card">
					<header class="card-header">
						<h3 class="card-title">Change Password</h3>
					</header>
					<div class="card-body">
						<form>
							<div class="form-group">
								<label for="new-pw">New Password</label>
								<input id="new-pw" type="password" v-model="newPass">
								<p class="input-error" v-if="errors.errors['password']">{{ errors.errors['password'] }}</p>
							</div>
							<div class="form-group">
								<label for="new-pw-2">New Password Again</label>
								<input id="new-pw-2" type="password" v-model="newPassVerification">
							</div>
							<div class="text-center mt-2">
								<a href="#" class="btn btn-md btn-primary" @click="savePassword"><i class="fas fa-check"></i> Set New Password</a>
							</div>
						</form>
					</div>
				</div>
			</aside>
		</div>
	</div>
</template>

<script>
	import Errors from '../../Utils/Errors.js'

	export default {
		props: {
			dataUserGeneral: {
				type: Object
			},
			dataUserSocial: {
				type: Object
			},
			dataProviders: {
				type: Array
			}
		},
		data() {
			return {
				userGeneral: this.dataUserGeneral,
				userSocial: this.dataUserSocial,
				providers: this.dataProviders,
				userVpnChoice: null,
				errors: new Errors(),
				newPass: '',
				newPassVerification: '',
				image: this.dataUserGeneral.avatar,
				file: '',
				inProgress: false,
				userRoles: this.$currentUserRoles,
			}
		},
		created() {
			let vm = this;

			if (vm.userGeneral.providerId !== 0) {
				let obj = vm.providers.find(o => o.id === vm.userGeneral.providerId);
				vm.userVpnChoice = vm.providers.indexOf(obj);
			} // if
		},
		methods: {
			deleteResource: function (id, user) {
				this.$dialog.confirm('Are you sure you want to delete ' + user + '?', {
					loader: true
				})
					.then((dialog) => {
						axios.delete('/api/users/' + id)
							.then(({data}) => {
								if (data.success) {
									dialog.close();
									window.location.replace("/users");
								} else {
									dialog.close();
									this.$toastr.error('Delete failed. User is assigned to articles.');
								} // if
							})
							.catch(errors => {
								dialog.close();
								this.$toastr.error('Delete failed.');
							});
					})
					.catch(() => {
						this.$toastr.error('Delete aborted.');
					});
			},
			saveGeneral: function () {
				let vm = this;

				let userObject = {
					general: vm.userGeneral,
					social: vm.userSocial
				};
				if (vm.userVpnChoice !== null) {
					userObject.provider = {
						user_id: vm.userGeneral.id,
						provider_id: vm.providers[vm.userVpnChoice].id,
						provider_name: vm.providers[vm.userVpnChoice].name,
					}
				} // if

				for (var propName in userObject.social) {
					if (userObject.social.hasOwnProperty(propName)) {
						if (userObject.social[propName] === null || userObject.social[propName] === ''
								|| userObject.social[propName] === undefined) {
							delete userObject.social[propName];
						}
					}
				}

				axios.put('/api/users/' + vm.userGeneral.id, userObject)
					.then(response => {
						vm.$toastr.success('User saved successfully', 'Success');
						window.location.reload();
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						vm.$toastr.error('User save failed.', 'Error');
					});
			},
			savePassword: function () {
				let vm = this;

				if (vm.newPass.length <= 6) {
					vm.errors.record({errors: {password: ['The given passwords are less then 6 characters!']}});
					vm.$toastr.error('The given passwords are less then 6 characters!', 'Error');
					return;
				}

				if (vm.newPass !== vm.newPassVerification) {
					vm.errors.record({errors: {password: ['The given passwords are not match!']}});
					vm.$toastr.error('The given passwords are not match!', 'Error');
					return;
				}

				axios.post('/api/users/' + vm.userGeneral.id + '/savePassword/', {password: vm.newPass})
					.then(response => {
						vm.$toastr.success('User password saved successfully', 'Success');
						window.location.reload();
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						vm.$toastr.error('User save failed.', 'Error');
					});
			},
			handleFileUpload: function () {
				this.inProgress = true;
				if (this.image) {
					this.file = this.$refs.fileChange.files[0];
				} else {
					this.file = this.$refs.file.files[0];
				}

				if (this.file) {

					let reader = new FileReader();

					reader.onload = (e) => {
						this.image = e.target.result;

						let formData = new FormData();

						formData.append('file', this.file);

						axios.post('/api/users/' + this.userGeneral.id + '/uploadAvatar',
							formData,
							{
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							}
						).then(response => {
							if (response.data.success) {
								this.$toastr.success('Avatar uploaded successful.', 'Success');
							} else {
								this.$toastr.error('Avatar uploaded failed.', 'Error');
							}
							this.inProgress = false;
						}).catch(e => {
							this.$toastr.error('Avatar uploaded failed.', 'Error');
						});
					};
					reader.readAsDataURL(this.file);
				}
			}
		}
	}
</script>
